import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-gis-position',
  templateUrl: './gis-position.component.html',
  styleUrls: ['./gis-position.component.css']
})
export class GisPositionComponent implements OnInit {
    public gisPositionKeyno: string;

    public location?: Location;

    public readyGisPositionNote = true;

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.gisPositionKeyno = this.stateService.getStateParams()['gisposition_keyno'];
    }

    private async loadLocation() {
        if (!!this.gisPositionKeyno) {
            this.location = (await this.datatask.Post(1286, { gisposition_keyno: this.gisPositionKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.location) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1287, this.location))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.location) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    const response = (await this.datatask.Post(1288, this.location))[0];

                    if (response.errorcode !== '0') {
                        this.modal.show({
                            type: 'warning',
                            title: 'error',
                            message: response.errormessage
                        });
                    } else {
                        this.stateService.back();
                    }
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    public openGoogleMaps() {
        if (!!this.location?.google_url) {
            window.open(this.location!.google_url);
        }
    }

    public openFinn() {
        if (!!this.location?.finn_url) {
            window.open(this.location!.finn_url);
        }
    }

    private async init() {
        this.loadLocation();
    }

    ngOnInit() {
        this.init();
    }
}

interface Location {
    gisposition_keyno: string;
    gispositiontype_keyno: string;
    gisposition_name: string;
    gisposition_note: string;
    reg_by_portal_user_keyno: string;
    reg_by_portal_user_name: string;
    lat: string;
    lng: string;
    position_accuracy_m: string;
    altitude_m: string;
    pos_datetime: string;
    source_note: string;
    argtype: string;
    argvalue: string;
    altitude_accuracy_m: string;
    google_url: string;
    finn_url: string;
}
